import { getDatabase, ref, child, update, get, set, remove, push } from "firebase/database";
import { getDownloadURL, ref as ref_storage } from "firebase/storage";
import firebase, { auth } from "../../firebase/config";
import { v4 as uuid } from "uuid";
import { getFormatedValue } from "../../utils/utils";

export const optimizationRun = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[START OPTIMIZATION]", item);

    // let analysis_id;
    await fetch(
      `https://us-central1-lokalite-saas.cloudfunctions.net/findLCAFlowsAlternatives?PARAMS=${encodeURIComponent(JSON.stringify(item.PARAMS))}
    &ANALYSIS_INFO=${encodeURIComponent(JSON.stringify(item.ANALYSIS_INFO))}`
      // { headers: headers,  }
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log("[optimizationRun success] - res: ", json);
        // if (json.status === 'success') {
        // analysis_id = json.analysis_id
        dispatch({ type: "OPTIMIZATION_RUN", payload: json.status, analysis_id: json.analysis_id });
        // } else {
        //   dispatch({ type: "OPTIMIZATION_RUN", payload: "error" });
        // }
      });
  };
};

export const resetOptimisationStatus = () => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[RESET_OPTIMIZATION_STATUS]");
    dispatch({ type: "RESET_OPTIMIZATION_STATUS" });
  };
};
export const fetchOptimization = (optimization_id) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[START FETCH OPTIMIZATION]", optimization_id);

    const tenant_id = auth.currentUser.tenantId;
    const dbRef = ref(firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/"));

    await get(child(dbRef, `optimization/${optimization_id}`))
      .then(async (snapshot) => {
        if (await snapshot.exists()) {
          const data = snapshot.val();
          console.log("[END FETCH OPTIMIZATION] - RESULTS:", data);
          dispatch({
            type: "FETCH_OPTIMIZATION",
            payload: { data: data, loading: false },
          });
        } else {
          console.log("[END FETCH OPTIMIZATION] - NO DATA:");
          dispatch({
            type: "FETCH_OPTIMIZATION",
            payload: { data: null, loading: true },
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const setOptimizationId = (analysis_id) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SET_OPTIMIZATION_ID]");
    dispatch({ type: "SET_OPTIMIZATION_ID", payload: analysis_id });
  };
};

const sort_analysis_history_by_date = (analysis_history) => {
  var result = {};
  Object.keys(analysis_history).forEach((key) => {
    result[key] = analysis_history[key];
    result[key]["createdAt"] = new Date(analysis_history[key]["createdAt"]);
  });
  console.log(result);

  const sorted_array = Object.entries(result).sort(function compare(a, b) {
    var dateA = a[1].createdAt;
    var dateB = b[1].createdAt;
    // console.log("dateA", dateA - dateB)
    return dateB - dateA;
  });

  var result_sorted = {};
  sorted_array.map((x) => {
    result_sorted[x[0]] = x[1];
    const d = result_sorted[x[0]]["createdAt"];
    result_sorted[x[0]]["createdAt"] = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + ", " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
  });
  return result_sorted;
};

export const fetchOptimizationHistory = () => {
  return async (dispatch, getState, { getFirebase }) => {
    // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
    // DOC: https://firebase.google.com/docs/functions/callable
    console.log("[FETCH_OPTIMIZATION_HISTORY]");
    const tenant_id = auth.currentUser.tenantId;
    const dbRef = ref(firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/"));
    await get(child(dbRef, "optimization_history/"))
      .then(async (snapshot) => {
        if (await snapshot.exists()) {
          const data = await snapshot.val();
          const history_sorted = sort_analysis_history_by_date(data);
          console.log("[FETCH_OPTIMIZATION_HISTORY] - DONE:", history_sorted);
          dispatch({
            type: "FETCH_OPTIMIZATION_HISTORY",
            payload: { history: history_sorted, loading: false },
          });
        } else {
          dispatch({
            type: "FETCH_OPTIMIZATION_HISTORY",
            payload: { history: [], loading: false },
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const setOptimizationHistory = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SET_OPTIMIZATION_HISTORY_FILTRED]", data);
    dispatch({
      type: "SET_OPTIMIZATION_HISTORY_FILTRED",
      payload: { history: data, loading: false },
    });
  };
};

export const removeOptimization = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_OPTIMIZATION]", item);
    const tenant_id = auth.currentUser.tenantId;
    const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
    // remove optimiation
    await remove(ref(database, `optimization/${item}`));
    // remove analysis history
    await remove(ref(database, `optimization_history/${item}`));
    dispatch({ type: "REMOVE_OPTIMIZATION" });
  };
};

export const removeOptimizationLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_OPTIMIZATION_LOCAL]", item);
    dispatch({ type: "REMOVE_OPTIMIZATION_LOCAL", payload: item });
  };
};
